import { Button } from 'antd';
import { CSSProperties } from 'react';
import styled from '@emotion/styled';

export const SubmitButton = styled(Button)<{ height?: CSSProperties['height'] }>((props) => ({
  height: props.height,
  width: '-webkit-fill-available',
}));
